import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store' // 引入 Vuex store
import Login from './login';
import Goods from './goods';
import Public from './public';
import Order from './order';
import User from './user';
import Config from './config';
import Coupon from './coupon';
import Healthy from './healthy';
import Device from './device';
import Distributor from './distributor';
import Integral from './integral.js';
import Plugin from './plugin.js';
import Merchant from './merchant';
import Problem from './problem';
import StoreMember from "./store_member";
import Private from "./private";
import Canvas from "./canvas.js";
import Clinic from "./clinic";
import Jiugong from "./jiugong";
import Activity from "./activity";
import Marketing from './marketing';
import Seckill from './seckill';
import Statistics from "./statistics";
import Shop from './shop';
import Mechanism from './mechanism'

Vue.use(VueRouter);
// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
// 修改原型对象中的push方法
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
};
const routes = [
  ...Public,
  ...Login,
  ...Goods,
  ...Order,
  ...User,
  ...Config,
  ...Coupon,
  ...Healthy,
  ...Device,
  ...Distributor,
  ...Integral,
  ...Plugin,
  ...Merchant,
  ...Problem,
  ...StoreMember,
  ...Private,
  ...Canvas,
  ...Clinic,
  ...Jiugong,
  ...Activity,
  ...Marketing,
  ...Seckill,
  ...Statistics,
  ...Shop,
  ...Mechanism
];

const router = new VueRouter({
  routes,
  mode: 'history',
  // mode: 'hash',
  scrollBehavior (to, from, savedPosition) {
  	return { x: 0, y: 0}
  }
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 检查是否是返回操作
  if (router.isBack) {
    // 清除即将离开页面的缓存
    if (from.meta.keepAlive) {
      store.commit('DEL_CACHED_VIEW', from.name)
    }
    // 重置标志
    router.isBack = false
  }

  // 添加新页面的缓存
  if (to.meta.keepAlive) {
    store.commit('ADD_CACHED_VIEW', to.name)
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js